export default __webpack_public_path__ + "static/media/graphic_2.b47ad0f4.svg";